/**
 * Pre-compiled fr-FR messages for SearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearInput: `Effacer les données de recherche` };
